import React from 'react';
import styled from 'styled-components';

import { media } from '~/utils';

/** @param {{ socialImpacts: Array<import("~/models/SocialImpact").default> }} props */
export default function ({ socialImpacts }) {
  return (
    <Wrapper>
      <Title>ソーシャルインパクト</Title>
      <Main>
        {socialImpacts.map((si, i) => (
          <SocialImpact key={i}>
            <ImageWrapper>
              <Image src={si.value === 0 ? si.imageDisabled : si.image} alt='image-social-impact' />
            </ImageWrapper>
            <Name disabled={si.value === 0}>{si.name}</Name>
            <Bars>
              <DisabledBar />
              <Bar value={si.value} />
            </Bars>
            <Value disabled={si.value === 0}>{si.value}</Value>
          </SocialImpact>
        ))}
      </Main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  ${media.mid`
    border-radius: 0;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Main = styled.div``;

const SocialImpact = styled.div`
  padding: 10px 35px;
  border-bottom: 1px solid #dedede;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }
`;

const ImageWrapper = styled.div`
  width: 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img``;

const Name = styled.div`
  width: 160px;
  margin-left: 14px;
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.disabled ? '#D8D8D8' : '#383838')};
`;

const Bars = styled.div`
  flex: 1;
  position: relative;
`;

const DisabledBar = styled.div`
  height: 8px;
  border-radius: 4px;
  width: 100%;
  background: #d8d8d8;
`;

const Bar = styled(DisabledBar)`
  position: absolute;
  top: 0;
  left: 0;
  background: #383838;
  width: ${(props) => (props.value / 5) * 100}%;
`;

const Value = styled.div`
  margin-left: 20px;
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.disabled ? '#D8D8D8' : '#383838')};
`;
